// removed by extract-text-webpack-plugin
module.exports = {"msignaturepad":"styles__msignaturepad___2cpth","m-signature-pad--body":"styles__m-signature-pad--body___WoqUZ","m-signature-pad--footer":"styles__m-signature-pad--footer___1r2Yx","description":"styles__description___4WBIp","button":"styles__button___5dMJr","clear":"styles__clear___mWGEt","save":"styles__save___yMC6L","m-signature-pad":"styles__m-signature-pad___3KtGj","github":"styles__github___26Onn","container":"styles__container___2-tND"};


//////////////////
// WEBPACK FOOTER
// ./client/app/screens/main/screens/phases/phaseShow/tabs/phaseContractVerification/styles.scss
// module id = TAhH
// module chunks = client